/**
 * 用户信息
 */

import cookie from "../cookie";

/**
 * 用户
 */
var user = {
    /**
     * 获取用户信息
     */
    get: function(){
        if (cookie.get('ut') && cookie.get('ct') && cookie.get('uidal')) {
            return {
              id: cookie.get('uidal')!.substring(0,16),
              nick: cookie.get('uidal')!.substring(16)
            };
        }
        return null; 
    },
    /**
     * 退出登录
     * @param  {function} 退出之后回调
     */
    logOut: function (callback:any) {
        var date = new Date();
        document.cookie = "pi=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        document.cookie = "ct=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        document.cookie = "ut=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        document.cookie = "uidal=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        if (callback) {
            callback();
        }
    },
    isLogin: function (){
        if( this.get() ){
            return true;
        }
        else{
            return false;
        }
    },
    gotoLogin: function(){
        var loginurl = 'https://passport2.eastmoney.com/pub/login?backurl=' + encodeURIComponent(self.location.href)
        self.location.href = loginurl
    }
};

export default user;



